module.exports = __webpack_public_path__ + "img/r.b58f4fa2.jpg";